import { IFormErrors } from '@interfaces/IFormsErrors';
import { IStudentWork } from '@interfaces/IStudentWork';
import { IStudentWorkReview } from '@interfaces/IStudentWorkReview';
import { IStudentWorksStats } from '@interfaces/IStudentWorksStats';
import { IReviewTemplates } from '@interfaces/IReviewTemplates';

export interface IStudentWorkState {
  studentWorks: IStudentWork[];
  urgentHomeworksCount: number;
  challenge_count: number;
  count: number;
  success: boolean;
  errors: { [key: string]: { [key: string]: string[] } };
  loading: { [key: string]: boolean };
  newWorksStats: IStudentWorksStats;
  allWorksStats: IStudentWorksStats | null;
  selectWorkReview?: IStudentWorkReview;
  takeInCheckLoading: boolean;
  autoAssignLoading: boolean;
  autoAssignSuccess: boolean;
  publishLoading: boolean;
  autoAssignErrors: IFormErrors | null;
  reviewTemplates: IReviewTemplates[];
  reviewTemplatesLoading: boolean;
}

export const initialStudentWorkState: IStudentWorkState = {
  allWorksStats: null,
  autoAssignErrors: null,
  autoAssignLoading: false,
  autoAssignSuccess: false,
  challenge_count: 0,
  count: 0,
  errors: {},
  loading: {},
  newWorksStats: {
    total: 0,
    groups: [],
  },
  publishLoading: false,
  reviewTemplates: [],
  reviewTemplatesLoading: false,
  studentWorks: [],
  success: false,
  takeInCheckLoading: false,
  urgentHomeworksCount: 0,
};
